<script>
import axios from 'axios';
import { mapState } from 'vuex';
import snackbarMixin from '@/mixins/snackbar';
import mainViewTabMixin from '../../mixins/mainViewTab';
import paginationMixin from '../../mixins/pagination';
import HistoryListItem from './components/HistoryListItem';

export default {
  name: 'History',
  components: {
    HistoryListItem,
  },
  mixins: [mainViewTabMixin, paginationMixin, snackbarMixin],
  props: {
    domain: {
      type: String,
      required: true,
    },
    domainId: {
      type: Number,
      required: true,
    },
    path: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      isInitialized: false,
      headers: [{ value: 'propertyName', text: 'Feld' },
        { text: 'Alter Wert', value: 'oldValue' }, { text: 'Neuer Wert', value: 'newValue' },
        { text: 'Geändert von', value: 'user' }, { text: 'Geändert am', value: 'lastUpdated' }],
      historyList: [],
    };
  },
  computed: {
    ...mapState(['history']),
    ...mapState('history', ['meta']),
  },
  mounted() {
    this.fetchHistory();
  },
  methods: {
    fetchHistory() {
      let uri = '/';

      if (this.domain && this.domainId) {
        uri += `${this.domain}/${this.domainId}/`;
      }
      uri += 'history';

      const self = this;

      axios.get(uri)
        .then((history) => {
          console.log('history');
          console.log(history);
          self.historyList = history;


          // history.data.forEach(function(it) {console.log(it); return self.historyList.push(it)});
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<template>
  <div class="tom-list">
    <template>
      <v-toolbar dark dense height="40" color="blue-grey lighten-2"/>

      <v-data-table
        :headers="headers"
        :items="historyList.data"
        :disable-initial-sort="true"
        :pagination="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :total-items="this.pagination.totalItems"
        :expand="true"
        item-key="id"
        @update:pagination="loadNextPage"
        rows-per-page-text="Zeilen pro Seite"
        no-data-text="keine Daten verfügbar"
        class="elevation-1 js-table"
      >
        <template slot="items" slot-scope="props">
          <history-list-item :history="props.item" :domain="domain" :expanded="props.expanded"/>
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
          von {{ pageStart }} bis {{ pageStop }}
        </template>
      </v-data-table>
    </template>

  </div>
</template>

<style lang="scss" scoped>
.variant-cell {
  width: 30px;

  i {
    cursor: pointer;
  }
}
</style>
